const iconClassName = 'h-4 w-4 shrink-0';

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="currentColor">
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.2 31.2 0 0 0 0 12a31.2 31.2 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.2 31.2 0 0 0 24 12a31.2 31.2 0 0 0-.5-5.8ZM9.5 15.7V8.3l6.3 3.7-6.3 3.7Z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3.75 6.75h16.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5Z" />
    <path d="m3 7.5 9 6 9-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={iconClassName} fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3.25" y="3.25" width="17.5" height="17.5" rx="4.75" />
    <circle cx="12" cy="12" r="4.25" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const PublicFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="public-footer border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-[90rem] px-4 py-4 sm:px-6 lg:px-8">
        <div className="public-footer-row">
          <p className="public-footer-copyright">&copy; {year} GenKalvi Academy</p>

          <div className="public-footer-links">
            <a
              href="https://www.youtube.com/@genkalvi-academy"
              target="_blank"
              rel="noreferrer"
              className="public-footer-link"
            >
              <YouTubeIcon />
              <span>@genkalvi-academy</span>
            </a>
            <a
              href="mailto:genkalviacademy@gmail.com"
              className="public-footer-link"
            >
              <MailIcon />
              <span>genkalviacademy@gmail.com</span>
            </a>
            <a
              href="https://www.instagram.com/genkalviacademy"
              target="_blank"
              rel="noreferrer"
              className="public-footer-link"
            >
              <InstagramIcon />
              <span>genkalviacademy</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
